import BaseInput from "../components/BaseInput/BaseInput";
import BaseButton from "../components/BaseButton/BaseButton";
import {useDispatch, useSelector} from 'react-redux'
import Modal from "../components/Modal/modal";
import useModal from "../components/Modal/useModal";
import AhamoveIdInfo from "../components/AhamoveIdInfo/AhamoveIdInfo";
import {useNavigate, useSearchParams} from "react-router-dom";
import {InvoiceAdditionalInputList, InvoiceInputList, ahamoveIdInput} from "../constants/InputItem";
import {getInvoice} from "../services/invoice";
import {setInvoiceData} from "../store/slices/invoiceSlice";
import {useEffect, useState} from "react";
import Loading from "../components/Loading/Loading";
import AhamoveIdInput from "../components/AhamoveIdInput/AhamoveIdInput";
import {buttonTheme} from "../components/BaseButton/buttonTheme";


function InputList(props) {
    const listItems = props.inputList.map((inputItem) => (<div className={'py-2 pt-1'} key={inputItem.id}>
        <BaseInput inputType={inputItem.inputType} label={inputItem.label}
                   inputId={inputItem.id} icon={inputItem.icon}/>
    </div>));
    return (<div>
        {listItems}
    </div>);
}


export default function Home() {
    const navigate = useNavigate();
    const {isShowing, toggle} = useModal();
    const [isLoading, setLoading] = useState(false)
    const [isValidUserId, setValidUserId] = useState(true)
    let [searchParams] = useSearchParams();
    const status = searchParams.get("status")
    const formId = searchParams.get("formId")
    const token = searchParams.get("token")
    const formData = useSelector(state => state.invoice.invoiceForm)

    const toConfirm = (status) => navigate({
        pathname: `/information?status=${status}`,
    })
    const dispatch = useDispatch()


    useEffect(() => {
        async function setUpInvoice() {
            try {
                if (status === 'modify') {
                    return
                }
                setLoading(true)
                let {data} = await getInvoice({token})
                if (data) {
                    dispatch(setInvoiceData({data}))
                    toConfirm('completed')
                }
                setLoading(false)
            } catch {
                setLoading(false)
            }
        }

        setUpInvoice()
    }, [])

    return (
        <div className={'w-full h-screen bg-slate-100 flex flex-col items-center justify-start'}>
            {isLoading ? <Loading isShowing={isLoading}/> : <div className={'max-w-screen-lg bg-white static'}>
                <div className={'p-3 pb-0 font-normal my-2 mb-3 lg:w-6/12 w-full'}>Vui lòng nhập đầy
                    đủ các thông
                    tin sau để thực
                    hiện yêu cầu rút hóa đơn
                </div>

                <div className={'sm:p-3 grid grid-cols-1 gap-5 sm:grid-cols-2'}>
                    <div className={'px-3 sm:p-0'}>
                        <InputList inputList={InvoiceInputList}/>
                        <div className={'pt-1'}>
                            <AhamoveIdInput key={ahamoveIdInput.id} label={ahamoveIdInput.label}
                                            inputId={ahamoveIdInput.id} onClickDropdown={toggle}
                                            setErrorStatus={setValidUserId}
                            />
                            {
                                !isValidUserId && (
                                 <div className={'text-rose-500'}>
                                     Invalid user id, please try again
                                 </div>
                                )
                            }
                        </div>
                    </div>
                    <div className={'px-3 sm:p-0 mb-24'}>
                        <div className={'font-bold mb-2'}>Yêu cầu bổ sung</div>
                        <InputList inputList={InvoiceAdditionalInputList}/>
                    </div>
                    <div
                        className={'drop-shadow sm:drop-shadow-none fixed bottom-0 w-full sm:static sm:p-0 bg-white'}>
                        <div className={'p-2'}>
                            <BaseButton buttonStyle={isValidUserId ? buttonTheme.confirm : buttonTheme.cancel}
                                        onClick={() => toConfirm('confirm')}
                                        label={'Tiếp tục'}/>
                        </div>
                    </div>
                </div>
                <Modal
                    isShowing={isShowing}
                    hide={toggle}
                    modalContent={<AhamoveIdInfo parentId={formData['parentId']}
                                                 childIdList={formData['childAhamoveId']} onClickConfirm={toggle}/>}
                />
            </div>}
        </div>);
}
